// src/pages/ShippingPolicy.js
import React from "react";

const sections = [
  {
    title: "1. Digital Delivery of Services",
    content: [
      "Once payment is successfully processed, your subscription is activated instantly.",
      "Users can immediately access premium features, live classes, and recorded sessions via the Revibe health and happiness application.",
      "A confirmation email or in-app notification will be sent with subscription details after successful purchase.",
    ],
  },
  {
    title: "2. Delivery Timeline",
    content: [
      "Subscriptions are typically activated within a few minutes of payment confirmation.",
      "In rare cases, activation may take up to 24 hours due to technical or banking delays.",
    ],
  },
  {
    title: "3. No Physical Shipping",
    content: [
      "Revibe health and happiness application does not ship physical goods, products, or printed materials.",
      "All services are delivered digitally only via our application.",
    ],
  },
  {
    title: "4. Technical Requirements",
    content: [
      "To access our services, users must ensure:",
      "A stable internet connection.",
      "A compatible device (Android, iOS smartphone/tablet, or Smart TV).",
      "The latest version of the Revibe health and happiness application is installed.",
    ],
  },
  {
    title: "5. Failed Delivery / Access Issues",
    content: [
      "If your subscription is not activated within 24 hours of payment, please contact our support team.",
      "We will investigate and resolve the issue at the earliest.",
    ],
  },
  {
    title: "6. Contact Us",
    content: [
      `Revibe Health and Happiness
2206, 22nd Floor, Solus, Hiranandani Estate,
Patlipada, Near Hiranandani School,
Thane (West), Maharashtra – 400607
Email: hello@getrevibe.app
Phone: +91 99677 22756`,
    ],
  },
];

const ShippingPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-12 xl:px-16 py-12">
      <h1 className="text-4xl font-bold mb-8 text-gray-900 text-center">
        Shipping & Delivery Policy
      </h1>

      <div className="space-y-8">
        {sections.map((section, index) => (
          <div key={index}>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              {section.title}
            </h2>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              {section.content.map((item, i) => (
                <li key={i} className="whitespace-pre-line">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* <p className="text-center text-gray-500 mt-12 text-sm">
        © {new Date().getFullYear()} Revibe Health and Happiness. All Rights
        Reserved.
      </p> */}
    </div>
  );
};

export default ShippingPolicy;
